import React from "react";
import CheckBox from "@_components/CheckBox/CheckBox";
import { caseConstants } from "@_constants/case.constants";
import styles from "./CaseActivityFilter.module.css";

const FILTER_OPTIONS = [
  {
    id: "case-activity-filter-communication",
    label: "Communication",
    category: caseConstants.CASE_ACTIVITY_CATEGORY_COMMUNICATION,
  },
  {
    id: "case-activity-filter-website-owner-action",
    label: "Website owner actions",
    category: caseConstants.CASE_ACTIVITY_CATEGORY_WEBSITE_OWNER_ACTION,
  },
  {
    id: "case-activity-filter-user-action",
    label: "Agent actions",
    category: caseConstants.CASE_ACTIVITY_CATEGORY_USER_ACTION,
  },
  {
    id: "case-activity-filter-other",
    label: "Other",
    category: caseConstants.CASE_ACTIVITY_CATEGORY_OTHER,
  },
];

function CaseActivityFilter({
  enabledCategories,
  onToggleCategory,
  categoryCounts = {},
}) {
  return (
    <div className={styles.activity_filter_row}>
      <span className={styles.activity_filter_label}>Show</span>
      {FILTER_OPTIONS.map(({ id, label, category }) => (
        <CheckBox
          key={id}
          id={id}
          label={`${label} (${categoryCounts[category] || 0})`}
          checked={!!enabledCategories[category]}
          onChange={() => onToggleCategory(category)}
        />
      ))}
    </div>
  );
}

export default CaseActivityFilter;
